export const PRICING_OUT_OF_DATE_LABEL = `Pricing out of date`

/** The one bodyless pricing command, wherever it is surfaced. */
export const REFRESH_PRICING_LABEL = `Refresh Pricing`
export const REFRESH_PRICING_BUSY_LABEL = `Refreshing`
export const REFRESH_PRICING_ERROR_PROMPT = `Unable to refresh pricing`

const PRICING_OUT_OF_DATE_TEST_ID = `pricing-out-of-date`

/** The gold out-of-date pill, for any stored figure that no longer matches its inputs. */
export const OutOfDateIndicator = ({
  label,
  testId,
}: {
  label: string
  testId?: string
}): JSX.Element => (
  <span
    role="status"
    data-testid={testId}
    className="inline-flex w-fit items-center rounded-full border border-bp-gold/40 bg-bp-gold/10 px-2.5 py-0.5 text-[length:var(--step--2)] font-medium text-bp-gold"
  >
    {label}
  </span>
)

export const PricingOutOfDateIndicator = ({
  testId = PRICING_OUT_OF_DATE_TEST_ID,
}: {
  testId?: string
}): JSX.Element => (
  <OutOfDateIndicator label={PRICING_OUT_OF_DATE_LABEL} testId={testId} />
)

/**
 * Inline variant for drawer footers and table cells, where a chip competes
 * with the action or the number beside it: icon plus gold label, no pill.
 */
export const OutOfDateNotice = ({
  label,
  testId,
}: {
  label: string
  testId?: string
}): JSX.Element => (
  <span
    role="status"
    data-testid={testId}
    className="inline-flex w-fit items-center gap-1.5 text-[length:var(--step--2)] font-medium text-bp-gold"
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      aria-hidden
      className="size-4 shrink-0"
    >
      <circle cx="12" cy="12" r="9" strokeWidth="1.75" />
      <path d="M12 7.5v5M12 16.25v.5" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
    {label}
  </span>
)

export const PricingOutOfDateNotice = ({
  testId = PRICING_OUT_OF_DATE_TEST_ID,
}: {
  testId?: string
}): JSX.Element => (
  <OutOfDateNotice label={PRICING_OUT_OF_DATE_LABEL} testId={testId} />
)
